import axios from 'axios';
import config from "../config";
import  secureLocalStorage  from  "react-secure-storage";

// const https = require('https');
//
// const agent = new https.Agent({
//     rejectUnauthorized: false,
// });

const instance = axios.create({
    baseURL: config.WS_BASE_URL,
});

instance.interceptors.request.use(async (config) => {
    const token = secureLocalStorage.getItem("token");
    config.headers.Authorization = (token ? token : '');
    config.headers.ContentType = 'application/json';
    return config;
});

///////////////////////////////////////////////////////
//Images Methods
export const getImage = async id => (
    await instance.post(`images/list/${id}`)
);
export const postImage = async (params) => (
    await instance.post('images/create', params)
);
///////////////////////////////////////////////////////

///////////////////////////////////////////////////////
//Checkout Methods
export const postOrder = async (params) => (
    await instance.post('checkouts/create', params)
);

export const captureOrder = async (orderId) => (
    await instance.post(`checkouts/capture/${orderId}`)
);

export const openGetAppData = async (alias) => (
    await instance.post(`apps/open/list/${alias}`)
);

///////////////////////////////////////////////////////

///////////////////////////////////////////////////////
//Payment Methods
export const getPayments = async (params) => (
    await instance.post('payments/list', params)
);

export const getPayment = async id => (
    await instance.post(`payments/list/${id}`)
);

export const postPayment = async (payment) => (
    await instance.post('payments/create', payment)
);

export const putPayment = async (payment) => (
    await instance.post('payments/edit', payment)
);

export const deletePayment = async (id) => (
    await instance.post(`payments/delete/${id}`)
);
///////////////////////////////////////////////////////

///////////////////////////////////////////////////////
//Coupon Methods
export const getCoupons = async (params) => (
    await instance.post('coupons/list', params)
);

export const getCoupon = async id => (
    await instance.post(`coupons/list/${id}`)
);

export const openGetCoupon = async code => (
    await instance.post(`coupons/open/list/${code}`)
);

export const postCoupon = async (coupon) => (
    await instance.post('coupons/create', coupon)
);

export const putCoupon = async (coupon) => (
    await instance.post('coupons/edit', coupon)
);

export const deleteCoupon = async (id) => (
    await instance.post(`coupons/delete/${id}`)
);
///////////////////////////////////////////////////////


///////////////////////////////////////////////////////
//Institution Methods
export const countInstitutions = async (params) => (
    await instance.post('institutions/count', params)
);

export const getInstitutions = async (params) => (
    await instance.post('institutions/list', params)
);

export const getInstitution = async id => (
    await instance.post(`institutions/list/${id}`)
);

export const postInstitution = async (institution) => (
    await instance.post('institutions/create', institution)
);

export const putInstitution = async (institution) => (
    await instance.post('institutions/edit', institution)
);

export const deleteInstitution = async (id) => (
    await instance.post(`institutions/delete/${id}`)
);
///////////////////////////////////////////////////////

///////////////////////////////////////////////////////
//Group Methods
export const getGroups = async (params) => (
    await instance.post('groups/list', params)
);

export const getGroup = async id => (
    await instance.post(`groups/list/${id}`)
);

export const postGroup = async (group) => (
    await instance.post('groups/create', group)
);

export const putGroup = async (group) => (
    await instance.post('groups/edit', group)
);

export const deleteGroup = async (id) => (
    await instance.post(`groups/delete/${id}`)
);
///////////////////////////////////////////////////////

///////////////////////////////////////////////////////
//Credential Type Methods
export const getCredentialTypes = async (params) => (
    await instance.post('credentialtypes/list', params)
);

export const getCredentialType = async id => (
    await instance.post(`credentialtypes/list/${id}`)
);

export const postCredentialType = async (device) => (
    await instance.post('credentialtypes/create', device)
);

export const putCredentialType = async (device) => (
    await instance.post('credentialtypes/edit', device)
);

export const deleteCredentialType = async (id) => (
    await instance.post(`credentialtypes/delete/${id}`)
);
///////////////////////////////////////////////////////

///////////////////////////////////////////////////////
//Credential Type Methods
export const getCredentials = async (params) => (
    await instance.post('credentials/list', params)
);

export const getCredential = async id => (
    await instance.post(`credentials/list/${id}`)
);

export const postCredential = async (device) => (
    await instance.post('credentials/create', device)
);

export const putCredential = async (device) => (
    await instance.post('credentials/edit', device)
);

export const deleteCredential = async (id) => (
    await instance.post(`credentials/delete/${id}`)
);
///////////////////////////////////////////////////////

///////////////////////////////////////////////////////
//Plan Methods
export const getPlans = async (params) => (
    await instance.post('plans/list', params)
);

export const getPlan = async id => (
    await instance.post(`plans/list/${id}`)
);

export const postPlan = async (device) => (
    await instance.post('plans/create', device)
);

export const putPlan = async (device) => (
    await instance.post('plans/edit', device)
);

export const deletePlan = async (id) => (
    await instance.post(`plans/delete/${id}`)
);
///////////////////////////////////////////////////////

///////////////////////////////////////////////////////
//Apps Methods
export const getApps = async (params) => (
    await instance.post('apps/list', params)
);

export const getApp = async id => (
    await instance.post(`apps/list/${id}`)
);

export const postApp = async (device) => (
    await instance.post('apps/create', device)
);

export const putApp = async (device) => (
    await instance.post('apps/edit', device)
);

export const deleteApp = async (id) => (
    await instance.post(`apps/delete/${id}`)
);
///////////////////////////////////////////////////////

///////////////////////////////////////////////////////
//Devices Methods
export const getDevices = async (params) => (
    await instance.post('devices/list', params)
);

export const getDevice = async id => (
    await instance.post(`devices/list/${id}`)
);

export const postDevice = async (device) => (
    await instance.post('devices/create', device)
);

export const putDevice = async (device) => (
    await instance.post('devices/edit', device)
);

export const deleteDevice = async (id) => (
    await instance.post(`devices/delete/${id}`)
);
///////////////////////////////////////////////////////

///////////////////////////////////////////////////////
//Account Methods
export const getAccountApps = async (params) => (
    await instance.post('accounts/appslist', params)
);
///////////////////////////////////////////////////////

///////////////////////////////////////////////////////
//Report Methods
export const reportStudentCollections = async (params) => (
    await instance.post('reports/students/collections', params)
);
export const reportAppUsage = async (params) => (
    await instance.post('reports/apps/usage', params)
);
///////////////////////////////////////////////////////

///////////////////////////////////////////////////////
//Students Methods
export const countStudents = async (params) => (
    await instance.post('students/count', params)
);

export const getStudents = async (params) => (
    await instance.post('students/list', params)
);

export const studentBoundList = async (params) => (
    await instance.post('students/boundlist', params)
);

export const getStudent = async id => (
    await instance.post(`students/list/${id}`)
);

export const postStudent = async (student) => (
    await instance.post('students/create', student)
);

export const bindStudent = async (student) => (
    await instance.post('students/bind', student)
);

export const putStudent = async (student) => (
    await instance.post('students/edit', student)
);

export const deleteStudent = async (id) => (
    await instance.post(`students/delete/${id}`)
);
///////////////////////////////////////////////////////

///////////////////////////////////////////////////////
//Subscription Methods
export const getSubscriptions = async (params) => (
    await instance.post('subscriptions/list', params)
);

export const getSubscription = async id => (
    await instance.post(`subscriptions/list/${id}`)
);

export const postSubscription = async (subscription) => (
    await instance.post('subscriptions/create', subscription)
);

export const putSubscription = async (subscription) => (
    await instance.post('subscriptions/edit', subscription)
);

///////////////////////////////////////////////////////


///////////////////////////////////////////////////////
//Installation Methods
export const getInstallations = async (params) => (
    await instance.post('installation/list', params)
);

export const getInstallation = async (id) => (
    await instance.post(`installation/list/${id}`)
);

export const boundInstallation = async (params) => (
    await instance.post('installation/bound', params)
);
///////////////////////////////////////////////////////

///////////////////////////////////////////////////////
//Installation Type Methods
export const getInstallationTypes = async (params) => (
    await instance.post('installationtypes/list', params)
);

export const getInstallationType = async id => (
    await instance.post(`installationtypes/list/${id}`)
);

export const postInstallationType = async (installationTypes) => (
    await instance.post('installationtypes/create', installationTypes)
);

export const putInstallationType = async (installationTypes) => (
    await instance.post('installationtypes/edit', installationTypes)
);

export const deleteInstallationType = async (id) => (
    await instance.post(`installationtypes/delete/${id}`)
);
///////////////////////////////////////////////////////


///////////////////////////////////////////////////////
// PROFILE METHODS
export const getUsers = async () => (
    await instance.post('users/list')
);


export const getUser = async id => (
    await instance.post(`users/list/${id}`)
);

export const register = async (name, email, password, captchaToken, phone, agency, role) => (
    await instance.post('users/register', {name, email, password, captchaToken, phone, agency, role})
);

export const verifyCaptcha = async (captchaToken) => {
    await instance.post('users/verify-captcha', {captchaToken})
}

export const confirmRegister = async id => (
    await instance.post(`users/confirm/${id}`)
);

export const forgotPassword = async email => (
    await instance.post('users/forgotpassword', {email})
);

export const confirmReset = async (id, password) => (
    await instance.post(`users/resetpass/${id}`, {password})
);

export const checkSession = async () => (
    await instance.post('users/checkSession')
);

export const login = async (email, password) => (
    await instance.post('users/login', {email, password, origin: 'site'})
);

export const logout = async token => (
    await instance.post('users/logout', {token})
);

export const putUser = async (user) => (
    await instance.post('/users/edit', user)
);
///////////////////////////////////////////////////////